import { ExclusionListsWebComponent } from './component/ExclusionListsWebComponent';
import { WEB_COMPONENT_EXCLUSION_LISTS } from '../../webcomponents.constants';

/**
 * The side-panel component for displaying lists
 * @link https://bitdefender.atlassian.net/wiki/spaces/GZDOCS/pages/1153468618/Global+Exclusions+Page
 */
export { ExclusionListsWebComponent };

window.customElements.define(WEB_COMPONENT_EXCLUSION_LISTS, ExclusionListsWebComponent);
